import { ROUTES } from './routes';
import { UserRole } from '../enums/user-role.enum';
import { AccessConfig } from '../interfaces/access-config.interface';

/**
 * Single source of truth for per-route role/task access.
 *
 * Consumed by BOTH the route guards (`app.routes.ts`) and the sidenav menu
 * (`sidenav.constants.ts`) so the roles that can see a link always match the
 * roles allowed to activate that route. Update access here only.
 */
export const ROUTE_ACCESS: Record<string, AccessConfig> = {
  [ROUTES.DASHBOARD.path]: {},
  [ROUTES.EMPLOYEE_MANAGEMENT.path]: { allowedRoles: [UserRole.TECH, UserRole.HR] },
  [ROUTES.ADDITIONAL_EMAILS.path]: { allowedRoles: [UserRole.TECH, UserRole.HR] },
  [ROUTES.ROLE_MANAGEMENT.path]: { allowedRoles: [UserRole.TECH] },
  [ROUTES.TASK_MANAGEMENT.path]: { allowedRoles: [UserRole.TECH] },
  [ROUTES.DEPARTMENT_MANAGEMENT.path]: { allowedRoles: [UserRole.TECH, UserRole.HR] },
  [ROUTES.DESIGNATION_MANAGEMENT.path]: { allowedRoles: [UserRole.TECH, UserRole.HR] },
  [ROUTES.BRAND_MANAGEMENT.path]: { allowedRoles: [UserRole.TECH] },
};
